module.exports = __webpack_public_path__ + "img/icon-save-light-blue.1964f54a.svg";